import { ReactEventHandler, useCallback, useState } from 'react';

export const useLoading = <T = any>(): [boolean, ReactEventHandler<T>] => {
    const [isLoaded, setLoaded] = useState<boolean>(false); 

    const onLoad = useCallback(() => setLoaded(true), []);

    return [isLoaded, onLoad];
}
